module.exports = __webpack_public_path__ + "static/img/transactionNum.7b054b2c.png";